import { http } from '@/services/http';

// ── Alertas / Notificações — ações e badge. ──────────────────────────────────
// A LEITURA da caixa vive em inbox.api.ts (GET /users/me/hexis/inbox): quem tria
// e explica é o Hexis. Aqui ficam só as ESCRITAS (marcar lido) e o contador do
// sino. O antigo getNotifications() — extrato cru da tabela, sem inteligência —
// foi removido de propósito: era o caminho fácil de volta a uma lista burra.

export async function markRead(id: string) {
  return http.post(`/users/me/notifications/${id}/read`, {}).catch(() => null);
}

export async function markAllRead() {
  return http.post('/users/me/notifications/read-all', {}).catch(() => null);
}

export interface NotifSummary { total: number; color: string; severity: 'info'|'warning'|'critical'; breakdown: Record<string, number>; }
export async function getNotificationsSummary(): Promise<NotifSummary> {
  try { return await http.get<NotifSummary>('/notifications/summary'); }
  catch { return { total: 0, color: 'var(--purple-50)', severity: 'info', breakdown: {} }; }
}
